import { Type } from "@google/genai";

export const SCRIPT_SCENE_BATCH_SCHEMA = {
  type: Type.OBJECT,
  properties: {
    scenes: {
      type: Type.ARRAY,
      items: {
        type: Type.OBJECT,
        properties: {
          scene_number: { type: Type.STRING, nullable: true },
          heading: { type: Type.STRING, nullable: true },
          script_text: { type: Type.STRING, nullable: true },
          description: { type: Type.STRING, nullable: true },
          script_page_range: { type: Type.STRING, nullable: true },
          characters: { type: Type.ARRAY, items: { type: Type.STRING } },
        },
      },
    },
  },
};
